import { userService } from '../../Services/userService';
import { RootState, useAppSelector } from '../../store';

export const SignOut = () => {
    const settings = useAppSelector((state: RootState) => state.settings);
    const signOut = () => {
        userService.logout().then(() => {
            localStorage.removeItem('loginProvider');
            document.location.href = settings.oidcLogoutUrl + document.location.href;
        });
    };

    return signOut;
};
